import React, { useEffect } from "react";
import { useMessageContext } from "../../Providers";
import AlertNotification from "./AlertNotification";
import '../../../../App/src/Assets/css/light-bootstrap-dashboard-pro-react.min.css'
import parse from 'html-react-parser';

function Notifications({ messageOptions }) {
    const notificationAlertRef = React.useRef(null);
    const { messageDispatch } = useMessageContext();
    const AUTO_DISMISS_SECONDS = 0;
    useEffect(() => {
        if (messageOptions.some((x) => x.type !== "CLOSE")) {
            notify(messageOptions[0].content);
        } else if (messageOptions.some((x) => x.type === "CLOSE")) {
            close();
        }
        return () => {
            messageDispatch({ type: "REMOVE_ALL" });
        };
    });
    function notify(content) {
        var options = {};
        options = {
            place: content.place,
            message: (
                <div style={{
                    paddingRight: '45px'
                }}>
                    {content.messages && content.messages.length ? (
                        content.messages.length > 1 ? (
                            <ul style={{ paddingLeft: "5px", margin: 0, padding: 0, marginLeft: '15px'}}>
                                {" "}
                                {content.messages.map((m) => (
                                    <li>{parse(m)}</li>
                                ))}{" "}
                            </ul>
                        ) : (
                            <div>{parse(content.messages[0])}</div>
                        )
                    ) : (
                        <div>{parse(content.message)}</div>
                    )}
                </div>
            ),
            type: content.type,
            icon: content.icon,
            autoDismiss: content.autoDismiss
                ? content.autoDismiss
                : AUTO_DISMISS_SECONDS,
            closeButton: content.closeButton,
        };
        notificationAlertRef.current?.notificationAlert(options);
    }

    function close() {
        notificationAlertRef.current?.closeAll();
    }

    return (
            <div className="rna-container">
                <AlertNotification ref={notificationAlertRef} />
            </div>
    );
}
export default Notifications;
